import Vue from 'vue';
import App from './components/App';
import router from './router';
import store from './store';
import vueConfig from './other/vueConfig.js';

console.log(process.env);

new Vue({
	el: '#app',
	router,
	store,
	render: (h) => h(App)
});


// WEBPACK FOOTER //
// ./src/main.js